import { axiosInstance } from './axiosInstance';

// Получить список поведений пользователя с первыми оценками в этой сессии для каждого из них
export const getUserBehaviors = (userId) =>
    axiosInstance.get('user/get_value_list', {
        params: {
            user: userId,
        },
    });

export const getFeedbackValuesData = (user, from) => {
    const userIdForAdminPanel = localStorage.getItem('user-id-for-admin-panel');
    const userId = localStorage.getItem('user-id');
    const teamId = localStorage.getItem('team-id');

    if (from) {
        return axiosInstance.get('user/get_value_list_with_feedback', {
            params: {
                user: user || userIdForAdminPanel || userId,
                from: from,
                team_id: teamId,
            },
        });
    } else {
        return axiosInstance.get('user/get_value_list_with_feedback', {
            params: {
                user: user || userIdForAdminPanel || userId,
                team_id: teamId,
            },
        });
    }
};

export const getAvatar = () => axiosInstance.get('user/get_avatar/');

export const updateAvatar = (data) => axiosInstance.post('user/update_avatar/', data);
